import theme from '../../theme';
export const styles = ()=>({
        divider: {
            borderColor: theme.colors.stroke[200]
        }
    });
